import { Button } from "@mui/material";
import { msgTypes } from "constants/msgTypes";
import { useEffect, useRef, useState } from "react";
import { EventsService } from "services/menu/eventsService/EventsService";
import ApiUrl from "services/shared/ApiUrl";
import { UtilService } from "services/shared/UtilService";
import DeleteIcon from '@material-ui/icons/Delete';

const EventGallery = ({ event, setOnSaved,setOnClose }) => {
    const { gallery } = event;
    const [selectedFile, setSelectedFile] = useState([]);
    const [selectedGallaryImage, setSelectedGallaryImage] = useState([]);
    const [counter, setCounter] = useState(0);
    const inputRef = useRef(null); // ✅ Ref for file input

    useEffect(() => {
        if (event?.eventId) {
            setSelectedFile(gallery || []);
        }
    }, [event]);

    useEffect(() => {
        if (selectedGallaryImage.length > 0) {
            setSelectedFile((prev) => [...prev, ...selectedGallaryImage]);
            setCounter((prev) => prev + 1);
        }
    }, [selectedGallaryImage]);

    const addEvents = async () => {
        if (selectedFile.length === 0) {
            return false;
        }
        const eventModel = { ...event, gallery: selectedFile };
        const res = await EventsService.addEvents(eventModel);
        if (res.statusMsg === msgTypes.SUCCESS.msg) {
            setOnSaved(true);
            setOnClose={setOnClose}
            return true;
        } else {
            return false;
        }
    };

    const handleFile = async (e) => {
        const files = e.target.files;
        const fileList = Array.from(files);
        const galleryImage = await Promise.all(
            fileList.map(async (data) =>
                data ? await UtilService.getImagePath(data) : ""
            )
        );
        setSelectedGallaryImage(galleryImage);

        // ✅ Clear the input value so same file can be selected again
        if (inputRef.current) {
            inputRef.current.value = "";
        }
    };

    const deleteImage = (index) => {
        const updatedFiles = [
            ...selectedFile.slice(0, index),
            ...selectedFile.slice(index + 1)
        ];
        setSelectedFile(updatedFiles);

        // ✅ Optionally clear file input on delete
        if (inputRef.current) {
            inputRef.current.value = "";
        }
    };

    return (
        <>
            <div className="App img-select mb-3">
                <input
                    type="file"
                    name="images"
                    id="imgid"
                    className="imgcls"
                    onChange={handleFile}
                    multiple
                    ref={inputRef} // ✅ Attach ref
                />
            </div>

            <div className="d-flex flex-wrap event-upload-section">
                {selectedFile?.map((file, index) => (
                    <div className="d-flex my-2 p-1 upload-event border" key={index}>
                        <div className="img-ulpoad-input">
                            <img src={ApiUrl.fileBaseUrl + file} alt="gallery" />
                        </div>
                        <div>
                            <DeleteIcon className="text-danger" onClick={() => deleteImage(index)} />
                        </div>
                    </div>
                ))}
            </div>

            <Button className="btn-submit btn text-white mt-3" onClick={addEvents}>
                Upload Image
            </Button>
        </>
    );
};

export default EventGallery;
